import React from 'react';
import Translate from "../../../../../../../../../components/Translate";
import Tooltip from "../../../../../../../../../components-new/general/Tooltip";
import InfoIcon from "../../../../../../../../../assets/icons/InfoIcon";
import Colors from "../../../../../../../../../utils/Colors";
import './AiConfigs.css';

/**
 * Card for one AI setting: a short title, an optional hint icon carrying the
 * long explanation, and the control itself. The explanations used to be the
 * headings, which left every block starting with a paragraph of text.
 */
const AiBlock = ({titleKey, hintKey, primary = false, children}) => (
    <div className={'ai-block' + (primary ? ' ai-block--primary' : '')}>
        <div className="ai-block__head">
            <h3 className="ai-block__title"><Translate text={titleKey}/></h3>

            {hintKey && (
                <Tooltip text={hintKey} inRightSide style={{display: 'flex'}}>
                    <span className="ai-block__hint">
                        <InfoIcon width={16} height={16} style={{color: Colors.silverBlueLite}} stroke="currentColor"/>
                    </span>
                </Tooltip>
            )}
        </div>

        {children}
    </div>
);

export default AiBlock;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiBlock.jsx